import { render, staticRenderFns } from "./CarrierOrders.vue?vue&type=template&id=045c1b4b&scoped=true&"
import script from "./CarrierOrders.vue?vue&type=script&lang=js&"
export * from "./CarrierOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c1b4b",
  null
  
)

export default component.exports